export const formatCurrency = (amount: number, fixed: number) => {
  if (amount === undefined || amount === null) {
    return 0;
  }
  return amount.toFixed(fixed).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
